
import { Components, PanelItem, Vertex2, Vertex3 } from '@rta/rta-blueprint-library';

import { convertPolyPoints2Vectors } from './convert-poly-points-2-vectors';
import { convertRect2Vectors } from './convert-rect-2-vectors';
import { Layer, type Vector } from '@r-core/types';

type GetApplianceVectorsProps = {
	panelItem: PanelItem;
	isCountertop: boolean;
};

export const getPanelItemVectors = ({ panelItem: pi, isCountertop }: GetApplianceVectorsProps): Array<Vector<Vertex2>> => {
	const showItemHint: boolean = pi.item.placement === Components.PLACEMENT_TOP_ONLY && !isCountertop;

	const countertopDepth = pi.refMap.island.overallSize.depth;

	const cutoutSize = pi.cutout;
	const cutoutOrigin = new Vertex3();
	const itemCorners = pi.getCorners()[isCountertop ? 'top' : 'front'];
	const cutoutCorners = pi.getCorners(true, isCountertop)[isCountertop ? 'top' : 'front'];

	let applianceOverlayVectors: Array<Vector<Vertex2>> = [];
	let applianceCutoutVectors: Array<Vector<Vertex2>> = [];
	let applianceHintVectors: Array<Vector<Vertex2>> = [];

	// if (isCountertop && uPanelItem.panelItem.item.placement === Components.PLACEMENT_FRONT_AND_TOP) {
	if (isCountertop && pi.item.placement === Components.PLACEMENT_FRONT_AND_TOP) {
		applianceOverlayVectors = convertPolyPoints2Vectors({
			vertices: itemCorners,
			depth: 0,
			layer: Layer.Overlay
		});

		// if (!pi.isStandAlone) {
		// 	applianceOverlayVectors = convertPolyPoints2Vectors({
		// 		vertices: cutoutCorners,
		// 		depth: 0,
		// 		layer: Layer.Overlay
		// 	});
		// }

		applianceCutoutVectors = convertPolyPoints2Vectors({
			vertices: cutoutCorners,
			depth: 0,
			layer: Layer.Panel
		});
	} else if (isCountertop || !pi.isDropIn) {
		if (pi.hasLandingZone) {
			applianceOverlayVectors = convertPolyPoints2Vectors({
				vertices: itemCorners,
				depth: 0,
				layer: Layer.Overlay
			});
		}

		applianceOverlayVectors = convertPolyPoints2Vectors({
			vertices: itemCorners,
			depth: 0,
			layer: Layer.Overlay
		});

		applianceCutoutVectors = convertPolyPoints2Vectors({
			vertices: cutoutCorners,
			depth: 0,
			layer: Layer.Panel
		});
	} else if (showItemHint) {
		applianceHintVectors = convertRect2Vectors({
			center: { x: cutoutOrigin.x, y: 0 },
			height: pi.item.distanceBelowCountertop - countertopDepth,
			width: cutoutSize.width,
			layer: Layer.Hint
		});
	}

	// console.log('getPanelItemVectors', pi.item.sku, {
	// 	applianceCutoutVectors: applianceCutoutVectors.map((v) => { return { f: [v.from.x, v.from.y], t: [v.to.x, v.to.y] } }),
	// 	applianceOverlayVectors: applianceOverlayVectors.map((v) => { return { f: [v.from.x, v.from.y], t: [v.to.x, v.to.y] } }),
	// 	applianceHintVectors: applianceHintVectors.map((v) => { return { f: [v.from.x, v.from.y], t: [v.to.x, v.to.y] } })
	// });

	return [
		...applianceCutoutVectors,
		...applianceOverlayVectors,
		...applianceHintVectors
	];
};
